// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'e2ff8a6a-cf1d-4c6c-bf36-f31842a13cab',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '95399067-f5f5-4c77-ac3e-3710db4383a9',
      type: 'Sprite',
      name: '',
      className: 'dynamicProps_SPL',
      x: -30,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 15.6,
        y: 2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'WinStreak_Blue_Gradient',
      parent: 'e2ff8a6a-cf1d-4c6c-bf36-f31842a13cab',
      data: {
        dynamicValues: {
          width: 'width * 1.1',
          height: 'height * 1.1'
        }
      }
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  handleResize: false
} as const;

export class WinScreenBackgroundLayout {
  static raw = raw;
  root!: Container;
  dynamicProps_SPL!: (Sprite & { data: typeof raw['list'][1]['data'] })[];
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
